module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("77yBt"))).then(() => module.bundle.root('hEqeo'));